import React, { useEffect, useState } from "react";
import "../../style.css";
import { Box, Typography, Chip, Tooltip, AppBar, Breadcrumbs, IconButton } from "@mui/material";
import DataTable from "react-data-table-component";
import { useProjectApiClient } from "../Services/api/projectService"
import { Pagination, PaginationItem } from "@mui/material";
import { useLoader } from "../../pages/LoaderContext";
import { Home, Restore } from "@mui/icons-material";
import { useAppContext } from '../../hooks/context/AppContext';
import { ToastContainer } from "react-toastify";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, Link } from "@mui/material";
import { GridDeleteIcon } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import alertIcon from "../../assets/images/alert.png";
import bulbIcon from "../../assets/images/bulb-light-icon.svg";
import { projectVersion } from "config/navConfig";


interface Project {
  project_key: string;
  Project_Id: string;
  bu: string;
  name: string;
  sclead: string;
  country: string;
  category: string;
  subCategory: string;
  brand: string;
  Launch_Year: string;
  launch_Month: string;
  launch_Week: string;
  ProjectStatus: string;
  bigBet: string;
  Bigbetvalue: string;
  uploadPic: string;
  Risk: string;
  comment: string;
  totalProjects: number;
  issaved: number;
  upload_pic?: string;
  country_key: string;
  category_Key: string;
  subcategory_key: string;
  brand_key: string;
  buid: number;
  sclead_key: number;
  risk_key: number;
  big_bet: number;
  Time_Key: number;
  project_name?: string;
  L2_Unilever_Cluster_Desc?: string;
  projectName?: string;
  project_id?: string;
  imageName?: string;
  project_attributes?: {
    toSaveMileStone?: boolean;
    country?: string;
    brand?: string;
    Launch_Year?: string;
  }[];
}

interface ProjectsListProps {
  selectedFilter: string;
  filters: Record<string, string>;
}

interface Permissions {
  CanRead: boolean;
  CanView: boolean;
  CanCopy: boolean;
  CanDelete: boolean;
  CanEdit: boolean;
  CanCreate: boolean;
  CanSoftDelete: boolean;
}

interface User {
  Email: string;
  FullName: string;
  Role: string;
  module: string;
  permissions: Permissions;
}

export default function DeletedProjectsList() {
  const { getRemovedProjects, deleteProject, restoreProject } = useProjectApiClient()
  const { userData } = useAppContext();
  const [user, setUser] = useState<User | null>(null);
  const [projects, setProjects] = useState<Project[]>([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(10);
  const [totalProjects, setTotalProjects] = useState(0);
  const { setLoading } = useLoader();
  const navigate = useNavigate();
  const [isRestoreDialogOpen, setIsRestoreDialogOpen] = useState(false);
  const [projectToRestore, setProjectToRestore] = useState<Project | null>(null);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [projectToDelete, setProjectToDelete] = useState<Project | null>(null);
  const { appData, updateAppData } = useAppContext();
  useEffect(() => {
    if (userData) {
      // @ts-ignore
      setUser(userData)
    }
  }, [userData]);

  const fetchProjects = async () => {
    setLoading(true);
    try {
      const data = await getRemovedProjects(page + 1, rowsPerPage);
      // @ts-ignore
      setProjects(data.projects); setTotalProjects(data.totalProjects);
    } catch (error) {
      console.error("Failed to fetch projects:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProjects();
  }, [page, rowsPerPage]);

  const customStyles = {
    headRow: {
      style: {
        backgroundColor: 'rgb(210 225 255)',
        fontWeight: 'bold',
        fontSize: '12px',
      },
    },
    headCells: {
      style: {
        justifyContent: 'flex-start' as const,
        textAlign: 'start' as const,
        paddingLeft: '8px',
        paddingRight: '8px',
      },
    },
    cells: {
      style: {
        fontSize: '12px',
        paddingLeft: '8px',
        paddingRight: '8px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textAlign: 'start' as const,
      },
    },
  };

  const handleDeleteProject = async () => {
    if (!projectToDelete) return;

    try {
      setLoading(true);
      // Call your delete project API here, example:
      await deleteProject(projectToDelete.project_id);

      // console.log("Deleting project:", projectToDelete.project_id);

      // Simulate API call delay
      setTimeout(() => {
        //console.log("Project deleted successfully");
        fetchProjects(); // Refresh the project list
        setIsDeleteDialogOpen(false);
        setProjectToDelete(null);
        setLoading(false);
      }, 1000);

    } catch (error) {
      console.error("Failed to delete project:", error);
      setLoading(false);
    }
  };
  const columns = [
    {
      name: '',
      width: '20px',
      selector: (row: any) => row.sNo,
      sortable: true,
      cell: (row: any) => (
        <Tooltip title={row.issaved ? 'Saved' : 'Draft'} placement="top" arrow>
          <span
            style={{
              display: 'block',
              width: '100%',
              height: '100%',
              backgroundColor: row.issaved ? '#16e17f' : '#f9a630', // green for saved, red for draft
            }}
          />
        </Tooltip>
      ),
    },
    {
      name: 'S.No',
      width: '60px',
      selector: (row: any) => row.sNo,
      sortable: true,
      cell: (row: any) => (
        <Tooltip title={row.sNo} placement="top" arrow>
          <span>{row.sNo}</span>
        </Tooltip>
      ),
    },
    {
      name: 'Project Name',
      width: '120px',
      selector: (row: any) => row.projectName,
      cell: (row: any) => (
        <Tooltip title={row.projectName} placement="top" arrow>
          <Typography
            variant="body2"
            sx={{
              fontSize: '13px',
              color: "blue",
              cursor: "pointer",
              "&:hover": { color: "darkblue" },
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
            // onClick={() => navigate(`${projectVersion}/project/project-info/${row.project_id}/view`)}
          >
            {row.projectName}
          </Typography>
        </Tooltip>
      ),
      sortable: true,

    },
    {
      name: 'SC Lead',
      selector: (row: any) => row.scLead,
      cell: (row: any) => (
        <Tooltip title={row.scLead} placement="top" arrow>
          <span style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}>{row.scLead}</span>
        </Tooltip>
      ),
      sortable: true,
    },
    {
      name: 'BU',
      selector: (row: any) => row.bu,
      cell: (row: any) => (
        <Tooltip title={row.bu} placement="top" arrow>
          <span style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}>{row.bu}</span>
        </Tooltip>
      ),
      sortable: true,
    },
    {
      name: 'Country',
      selector: (row: any) => row.country,
      cell: (row: any) => (
        <Tooltip title={row.country} placement="top" arrow>
          <span style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}>{row.country}</span>
        </Tooltip>
      ),
      sortable: true,
    },
    {
      name: 'Category',
      selector: (row: any) => row.category,
      cell: (row: any) => (
        <Tooltip title={row.category} placement="top" arrow>
          <span style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}>{row.category}</span>
        </Tooltip>
      ),
      sortable: true,
    },
    {
      name: 'Brand',
      width: '80px',
      selector: (row: any) => row.brand,
      cell: (row: any) => (
        <Tooltip title={row.brand} placement="top" arrow>
          <span style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}>{row.brand}</span>
        </Tooltip>
      ),
      sortable: true,
    },
    {
      name: 'Brand Position',
      selector: (row: any) => row.subCategory,
      cell: (row: any) => (
        <Tooltip title={row.subCategory} placement="top" arrow>
          <span style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}>{row.subCategory}</span>
        </Tooltip>
      ),
      sortable: true,
    },
    {
      name: 'Launch Year',
      width: '100px',
      selector: (row: any) => row.LaunchYear,
      cell: (row: any) => (
        <Tooltip title={row.LaunchYear} placement="top" arrow>
          <span style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}>{row.LaunchYear}</span>
        </Tooltip>
      ),
      sortable: true,
    },
    {
      name: 'Project Status',
      cell: (row: any) => (
        <Tooltip title={row.projectStatus === "Active" ? "Active" : "In-active"} placement="top" arrow>
          <span>{row.projectStatus === "Active" ? "Active" : "In-active"}</span>
        </Tooltip>
      ),
      sortable: true,
    },
    {
      name: 'Big Bet',
      width: '80px',
      selector: (row: any) => row.bigBet,
      cell: (row: any) => (
        <Tooltip title={row.bigBet} placement="top" arrow>
          <span style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}>{row.bigBet}</span>
        </Tooltip>
      ),
      sortable: true,
    },
    {
      name: 'Risk',
      width: '80px',
      cell: (row: any) => {
        let riskClass = "";
        switch (row.risk?.toLowerCase()) {
          case "high":
            riskClass = "high";
            break;
          case "medium":
            riskClass = "medium";
            break;
          case "low":
            riskClass = "low";
            break;
        }
        return (
          <Tooltip title={row.risk} placement="top" arrow>
            <span className={`risk ${riskClass}`}>{row.risk}</span>
          </Tooltip>
        );
      },
      sortable: true,
    },
    {
      name: 'Actions',
      width: '250px',
      cell: (row: any) => (
        <>
          {/* Restore Button */}
          <Tooltip title="Restore" placement="top" arrow>
            <Chip
              disabled={!user?.permissions?.CanDelete}
              sx={{
                backgroundColor: "#4caf50",
                color: "#ffffff",
                cursor: "pointer",
                paddingX: 1,
                minWidth: 70,
                height: 28,
                fontSize: 12,
                "& .MuiChip-label": {
                  display: "flex",
                  alignItems: "center",
                  gap: 0.2,
                },
                "&:hover": {
                  backgroundColor: "#388e3c",
                },
              }}
              label={
                <Box display="flex" alignItems="center" gap={0.3}>
                  <Restore sx={{ fontSize: 14, color: "#ffffff" }} />Restore
                </Box>
              }
              onClick={() => {
                setProjectToRestore(row);
                setIsRestoreDialogOpen(true);
              }}
            />

          </Tooltip>
          {/* Delete Button */}
          <Tooltip title="Delete" placement="top" arrow>
            <Chip
              disabled={!user?.permissions?.CanDelete}
              sx={{
                backgroundColor: "#f44336", // lighter red
                color: "#ffffff",            // white text
                cursor: "pointer",
                marginLeft: 0.5,
                paddingX: 1,
                minWidth: 60,
                height: 28,
                fontSize: 12,
                "& .MuiChip-label": {
                  display: "flex",
                  alignItems: "center",
                  gap: 0.2,
                },
                "&:hover": {
                  backgroundColor: "#e53935", // slightly darker on hover
                },
              }}
              label={
                <Box display="flex" alignItems="center" gap={0.3}>
                  <GridDeleteIcon sx={{ fontSize: 14, color: "#ffffff" }} />
                  Delete
                </Box>
              }
              onClick={() => {
                setProjectToDelete(row);
                setIsDeleteDialogOpen(true);
              }}
            />
          </Tooltip>

        </>
      ),
    },
  ];
  let handleHomeClick = () => {
    if (!appData.isFormChanged) {
      navigate(`${projectVersion}/projects-grid`)
    } else {
      updateAppData({ isFormChanged: true, showUnSavedModal: true, url: '/projects-grid' });
    }
  }
  let handleLandingClick = () => {
    if (!appData.isFormChanged) {
      navigate(`${projectVersion}/`);
    } else {
      updateAppData({ isFormChanged: true, showUnSavedModal: true, url: `/` });
    }
  }
  const handleRestore = async () => {
    if (!projectToRestore) return;
    try {
      setLoading(true);
      //console.log('Success to restore project:');
      await restoreProject(projectToRestore.project_id);
      fetchProjects();
    } catch (error) {
      console.error('Failed to restore project:', error);
    } finally {
      setLoading(false);
      setIsRestoreDialogOpen(false);
      setProjectToRestore(null);
    }
  };

  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: "transparent",
        boxShadow: "none",
        padding: "10px",
      }}
    >
      <ToastContainer />
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
        {/* Top Navigation Bar */}
        <Box className="breadcrumb-container" sx={{ mb: 1 }}>
          {" "}
          {/* Adjust mb to your liking */}
          <Breadcrumbs aria-label="breadcrumb">
            <IconButton onClick={handleLandingClick} sx={{ color: "#003399" }}>
              <Home fontSize="medium" />
            </IconButton>
            <Link
              underline="hover"
              color="inherit"
              onClick={handleHomeClick}
              sx={{ fontSize: "13px" }}
            >
              Back to List
            </Link>
          </Breadcrumbs>
        </Box>
      </Box>
      <Box sx={{ p: 2 }}>
        <div className="innoflex-help">
          <Typography
            variant="h6"
            sx={{ color: "#0033CC", fontWeight: 600, mb: 2, mt: 0 }}
          >
            Deleted Projects
          </Typography>
          <hr></hr>
          <br></br>
          <div className="data-grid-table">
            <div
              className="data-grid-table"
              style={{
                overflowX: "auto",
                padding: "20px",
                backgroundColor: "#fff ",
              }}
            >
              <Box
                className="boxBoder-Table"
                sx={{
                  padding: "0px",
                  backgroundColor: "white",
                  fontSize: "12px",
                }}
              >
                <DataTable
                  columns={columns}
                 data={projects.map((project, index) => {
                  const milestoneAttr = project.project_attributes?.find((attr: any) => attr.toSaveMileStone);

                    return {
                      issaved: project.issaved,
                      project_key: project.project_key,
                      project_id: project.Project_Id,
                      sNo: index + 1 + page * rowsPerPage,
                      projectName: project.name,
                      scLead: project.sclead,
                      bu: project.L2_Unilever_Cluster_Desc,
                      country: milestoneAttr?.country || project.country,
                      category: project.category,
                      brand: milestoneAttr?.brand || project.brand,
                      subCategory: project.subCategory,
                      LaunchYear: milestoneAttr?.Launch_Year || project.Launch_Year,
                      projectStatus: project.ProjectStatus,
                      bigBet: project.Bigbetvalue,
                      risk: project.Risk,
                      imageName: project.upload_pic,
                      category_Key: project.category_Key,
                      subcategory_key: project.subcategory_key,
                      brand_key: project.brand_key,
                    };
                  })}
                  customStyles={customStyles}
                  paginationServer
                  paginationTotalRows={totalProjects}
                  paginationPerPage={rowsPerPage}
                  paginationComponentOptions={{ noRowsPerPage: true }}
                  onChangePage={(newPage) => setPage(newPage - 1)}
                  responsive
                  noDataComponent={
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                      }}
                    >
                      <Typography variant="h6" color="textSecondary">
                        No Projects Found
                      </Typography>
                    </Box>
                  }
                />

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    padding: "10px",
                    width: "100%",
                    gap: "20px",
                  }}
                >
                  <Typography
                    sx={{ fontSize: 12, color: "blue", fontWeight: 600 }}
                  >
                    Total Projects
                    <Chip
                      label={totalProjects}
                      color="primary"
                      sx={{ marginLeft: 1 }}
                    />
                  </Typography>
                  <Pagination
                    count={Math.ceil(totalProjects / rowsPerPage)}
                    page={page + 1}
                    onChange={(_, newPage) => setPage(newPage - 1)}
                    siblingCount={1}
                    boundaryCount={1}
                    showFirstButton
                    showLastButton
                    renderItem={(item) => <PaginationItem {...item} />}
                  />
                </Box>
              </Box>
            </div>
          </div>
        </div>
      </Box>
      <Dialog open={isDeleteDialogOpen} onClose={() => setIsDeleteDialogOpen(false)} >
      <DialogTitle>
          <h3 className="modal-title">Confirm Delete Permanently</h3>
        </DialogTitle>
        <hr></hr>
        <DialogContent>
          <div className="save-card-wapper">
            <div className="alert-icon-wp">
              <img src={alertIcon} alt="" />
            </div>
            <h2 className="title-save-frm"></h2>
            <div className="txt-flex--mt">
              <span className="bulb-txt"><img src={bulbIcon} alt="" /></span>
              <p> Once deleted, this item can't be restored. Are you sure you want to delete it?</p>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button className="btn-cancel" onClick={() => setIsDeleteDialogOpen(false)} >
            Cancel
          </Button>
          <Button
            onClick={handleDeleteProject}
           className="btn-delete"
            variant="contained"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={isRestoreDialogOpen} onClose={() => setIsRestoreDialogOpen(false)}>
        <DialogTitle>
          <h3 className="modal-title">Confirm Restore</h3>
        </DialogTitle>
        <hr></hr>
        <DialogContent>
          <div className="save-card-wapper">
            <div className="alert-icon-wp">
              <img src={alertIcon} alt="" />
            </div>
            <h2 className="title-save-frm"></h2>
            <div className="txt-flex--mt">
              <span className="bulb-txt"><img src={bulbIcon} alt="" /></span>
              <p>Are you sure you want to restore this item? It will be returned to your project list in draft mode.</p>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button className="btn-cancel" onClick={() => setIsRestoreDialogOpen(false)} color="inherit">
            Cancel
          </Button>
          <Button className="btn-restore" onClick={handleRestore} color="primary" variant="contained">
            Restore
          </Button>
        </DialogActions>
      </Dialog>

    </AppBar>
  );
}